export const ItemsListColumns = [
  {
    Header: 'Item Name',
    accessor: 'item_name',
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'Unit',
    accessor: 'unit',
  },
  {
    Header: "Price",
    accessor: "item_total_cost",
  },
  {
    Header: "Purpose",
    accessor: "purpose",
  },
  // {
  //     Header: 'Unit Price',
  //     accessor: 'unit_price',
  //   },
  // {
  //     Header: 'Total',
  //     accessor: 'total',
  //   },
  // {
  //   Header: 'Actions',
  //   accessor: 'actions',
  // }
];